module.exports = __webpack_public_path__ + "img/midBanner01.ecc8b03a.png";